import { useState, useContext, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Card, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaFlag,
  FaCalendarAlt,
  FaUsers,
  FaExchangeAlt,
  FaArrowRight,
  FaClock,
  FaRoad,
  FaMoneyBillWave,
  FaCoins,
  FaCreditCard,
  FaCheckCircle,
  FaShieldAlt,
  FaInfoCircle,
  FaLock,
} from "react-icons/fa";
import Autocomplete from "react-google-autocomplete";
import "../../../assets/css/Customer/CustomerDashboard/CustomerRideSelection.css";
import "../../../assets/css/Customer/general/BottomNav.css";
import BottomNav from "../../../components/Customer/general/BottomNav";
import AppContext from "../../../context/AppContext";
import axios from "axios";


const CustomerRideSelection = () => {
  const navigate = useNavigate();
  const {
    baseUrl,
    selectedRideType,
    setSelectedRideforFindingDriver,
    selectedOffer,
    setSelectedOffer,
    GOOGLE_API_KEY
  } = useContext(AppContext);
  const mapRef = useRef(null);
  const authToken = localStorage.getItem("authToken");

  const [pickuplocation, setpickuplocation] = useState("");
  const [dropofflocation, setdropofflocation] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [bookingTime, setBookingTime] = useState("");
  const [passengers, setPassengers] = useState(1);
  const [bookingType, setBookingType] = useState("");
  const [vehicleType, setvehicleType] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [offeredFare, setofferedFare] = useState("");
  const [pickupLat, setPickupLat] = useState("");
  const [pickupLong, setPickupLong] = useState("");
  const [dropoffLat, setDropoffLat] = useState("");
  const [dropoffLong, setDropoffLong] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isEligible, setIsEligible] = useState(false);
  const [ridesRemaining, setRidesRemaining] = useState(10);

  const [driverType, setDriverType] = useState("male");
  const [femaleAvailable] = useState(false);

  const [showMapModal, setShowMapModal] = useState(false);
  const [mapTarget, setMapTarget] = useState("pickup");
  const [mapSelectedAddress, setMapSelectedAddress] = useState("");

  const [customerFareBid, setCustomerFareBid] = useState(0);
  const [fareEdited, setFareEdited] = useState(false);

  const [showInstallmentModal, setShowInstallmentModal] = useState(false);
  const [showNotEligibleModal, setShowNotEligibleModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [confirmingInstallment, setConfirmingInstallment] = useState(false);

  const handleSwap = () => {
    const temp = pickuplocation;
    setpickuplocation(dropofflocation);
    setdropofflocation(temp);
  };

  const rideTypes = [
    {
      id: "seater4",
      label: "4 Seater",
      seats: 4,
      icon: "",
      desc: "Comfortable sedan",
      pricePerSeat: 2500,
    },
    {
      id: "seater7",
      label: "7 Seater",
      seats: 7,
      icon: "",
      desc: "Spacious van",
      pricePerSeat: 3200,
    },
  ];

  const getRide = () =>
    rideTypes.find((r) => r.id === bookingType) || rideTypes[0];
  const getfareAmount = () => getRide().pricePerSeat * passengers;

  // ===== OFFER DISCOUNT CALCULATION =====
  const baseFare = fareEdited ? customerFareBid : getfareAmount();
  const discountPercent = selectedOffer
    ? parseFloat(selectedOffer.discount_percent)
    : 0;
  const discountAmount = selectedOffer
    ? Math.round((baseFare * discountPercent) / 100)
    : 0;
  const finalFareAfterDiscount = selectedOffer
    ? baseFare - discountAmount
    : baseFare;

  useEffect(() => {
    if (!fareEdited) setCustomerFareBid(getfareAmount());
    // eslint-disable-next-line
  }, [bookingType, passengers, fareEdited]);

  const handleFareBidChange = (val) => {
    if (val === "") {
      setCustomerFareBid("");
      setFareEdited(true);
      return;
    }
    const num = parseInt(val);
    if (!isNaN(num) && num >= 0) {
      setCustomerFareBid(num);
      setFareEdited(true);
    }
  };

  const resetFareBid = () => {
    setCustomerFareBid(getfareAmount());
    setFareEdited(false);
  };

  useEffect(() => {
    if (!showMapModal || !mapRef.current || !window.google) return;
    const defaultCenter = { lat: 31.5204, lng: 74.3587 };
    const map = new window.google.maps.Map(mapRef.current, {
      center: defaultCenter,
      zoom: 14,
      disableDefaultUI: true,
      zoomControl: true,
    });
    const geocoder = new window.google.maps.Geocoder();
    const existingLoc =
      mapTarget === "pickup" ? pickuplocation : dropofflocation;
    if (existingLoc) {
      geocoder.geocode({ address: existingLoc }, (res, st) => {
        if (st === "OK") map.setCenter(res[0].geometry.location);
      });
    }
    window.google.maps.event.addListener(map, "dragend", () => {
      const center = map.getCenter();
      geocoder.geocode(
        { location: { lat: center.lat(), lng: center.lng() } },
        (res, st) => {
          if (st === "OK" && res[0])
            setMapSelectedAddress(res[0].formatted_address);
        },
      );
    });
    geocoder.geocode({ location: defaultCenter }, (res, st) => {
      if (st === "OK" && res[0])
        setMapSelectedAddress(res[0].formatted_address);
    });
    // eslint-disable-next-line
  }, [showMapModal, mapTarget]);

  const getInstallmentPlans = () => {
    const total = fareEdited ? customerFareBid : getfareAmount();
    const fee3 = Math.round(total * 0.05);
    return [
      {
        id: "plan3",
        title: "3 Month Plan",
        badge: "Most Popular",
        badgeColor: "#1B9B82",
        desc: "Split into 3 equal monthly payments",
        serviceFee: fee3,
        totalPayable: total + fee3,
        monthly: Math.round((total + fee3) / 3),
        months: 3,
        perks: [
          "No hidden charges",
          "Instant approval",
          "Managed directly by Trustidrive",
        ],
      },
    ];
  };

  useEffect(() => {
    const formData = new FormData();
    axios.post(`${baseUrl}/customer/ride/checkEligibility`, formData, {
      headers: { Authorization: `Bearer ${authToken}` }
    }).then((res) => {
      if (res.data.success) {
        setIsEligible(res.data.eligible);
        setRidesRemaining(res.data.ridesRemaining);
      }
    }).catch((error) => console.log(error));
  }, []);

  // Handle click on installment payment card — gate by eligibility
  const handleInstallmentCardClick = () => {
    if (!isEligible) {
      setShowNotEligibleModal(true);
      return;
    }
    setPaymentMethod("installment");
  };

  const handleBookRide = () => {
    if (!pickuplocation || !dropofflocation) {
      alert("Please select cities!");
      return;
    }
    if (pickuplocation === dropofflocation) {
      alert("From and To city cannot be same!");
      return;
    }
    if (!bookingDate) {
      alert("Please select date!");
      return;
    }
    if (!bookingTime) {
      alert("Please select departure time!");
      return;
    }
    if (!paymentMethod) {
      alert("Please select a payment method!");
      return;
    }
    if (paymentMethod === "installment") {
      if (!isEligible) {
        setShowNotEligibleModal(true);
        return;
      }
      setShowInstallmentModal(true);
      return;
    }
    submitRide();
  };

  const submitRide = (planId = null) => {
    const fareToSend = selectedOffer ? finalFareAfterDiscount : baseFare;
    setofferedFare(fareToSend);
    const formData = new FormData();
    formData.append("pickuplocation", pickuplocation);
    formData.append("dropofflocation", dropofflocation);
    formData.append("bookingDate", bookingDate);
    formData.append("bookingTime", bookingTime);
    formData.append("passengers", passengers);
    formData.append("bookingType", selectedRideType);
    formData.append("paymentmethod", paymentMethod);
    formData.append("vehicleType", vehicleType);
    formData.append("pickupLat", pickupLat);
    formData.append("pickupLong", pickupLong);
    formData.append("dropoffLat", dropoffLat);
    formData.append("dropoffLong", dropoffLong);
    formData.append(
      "driverType",
      driverType === "female" && !femaleAvailable ? "top_rated" : driverType,
    );
    formData.append("offeredFare", fareToSend);
    formData.append("status", "request");
    if (planId) formData.append("installmentPlan", planId);

    if (selectedOffer) {
      formData.append("offer_id", selectedOffer.id);
    }

    axios
      .post(`${baseUrl}/customer/ride/createRide`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log("FULL RESPONSE:", response.data);
        setConfirmingInstallment(false);
        setShowInstallmentModal(false);
        setShowSuccessModal(true);
        setTimeout(() => {
          setShowSuccessModal(false);
          setSelectedRideforFindingDriver(response.data.ride);
          setSelectedOffer(null);
          navigate("/customer-finding-driver");
        }, 3000);
      })
      .catch((error) => {
        console.log(error);
        setConfirmingInstallment(false);
        alert("Network Error! Please try again.");
      });
  };

  // Confirm installment plan — books ride directly against the chosen plan,
  // fully handled inside Trustidrive (no external redirect).
  const handleInstallmentConfirm = () => {
    if (!selectedPlan) {
      alert("Please select an installment plan!");
      return;
    }
    setConfirmingInstallment(true);
    submitRide(selectedPlan);
  };

  const today = new Date().toISOString().split("T")[0];
  const plans = getInstallmentPlans();
  const finalFare = fareEdited ? customerFareBid : getfareAmount();

  return (
    <div className="customerrideselection-wrapper">
      {/* Header */}
      <div className="customerrideselection-header">
        <div className="customerrideselection-header-inner">
          <button
            className="customerInstantRide-navbar__back-btn"
            onClick={() => navigate(-1)}
          >
            ←
          </button>

          <h1 className="customerrideselection-title">City to City</h1>
          <div className="customerrideselection-header-spacer" />
        </div>
      </div>

      <Container className="customerrideselection-container">
        {/* ===== OFFER BANNER ===== */}
        {selectedOffer && (
          <Card className="customerrideselection-card customerrideselection-offer-banner">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="customerrideselection-offer-banner__title">
                  🎉 Offer Applied
                </span>
                <span className="customerrideselection-offer-banner__badge">
                  {selectedOffer.discount_percent}% OFF
                </span>
              </div>
              <p className="customerrideselection-offer-banner__desc">
                {selectedOffer.description}
              </p>
            </Card.Body>
          </Card>
        )}

        {/* ── ROUTE CARD ── */}
        <Card className="customerrideselection-card">
          <Card.Body className="customerrideselection-card-body">
            <p className="customerrideselection-section-label">Select Route</p>

            {/* Pickup */}
            <div className="customerrideselection-field-wrap">
              <div className="customerrideselection-field-icon customerrideselection-field-icon--from">
                <FaMapMarkerAlt />
              </div>
              <div className="customerrideselection-field-content">
                <label className="customerrideselection-field-label">
                  From
                </label>
                <div className="customerrideselection-input-wrap">
                  <Autocomplete
                    apiKey={GOOGLE_API_KEY}
                    className="customerrideselection-select form-control"
                    placeholder="Enter departure city"
                    defaultValue={pickuplocation}
                    onPlaceSelected={(place) =>
                      setpickuplocation(
                        place?.formatted_address || place?.name || "",
                      )
                    }
                    options={{
                      types: ["address"],
                      componentRestrictions: { country: "pk" },
                    }}
                  />
                  <button
                    className="customerrideselection-map-pin-btn"
                    onClick={() => {
                      setMapTarget("pickup");
                      setShowMapModal(true);
                    }}
                    title="Pick on Map"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                        fill="#1B9B82"
                      />
                      <circle cx="12" cy="9" r="2.5" fill="#ffffff" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div className="customerrideselection-swap-wrap">
              <div className="customerrideselection-dashed-line" />
              <button
                className="customerrideselection-swap-btn"
                onClick={handleSwap}
              >
                <FaExchangeAlt />
              </button>
              <div className="customerrideselection-dashed-line" />
            </div>

            {/* Dropoff */}
            <div className="customerrideselection-field-wrap">
              <div className="customerrideselection-field-icon customerrideselection-field-icon--to">
                <FaFlag />
              </div>
              <div className="customerrideselection-field-content">
                <label className="customerrideselection-field-label">To</label>
                <div className="customerrideselection-input-wrap">
                  <Autocomplete
                    apiKey={GOOGLE_API_KEY}
                    className="customerrideselection-select form-control"
                    placeholder="Enter destination city"
                    defaultValue={dropofflocation}
                    onPlaceSelected={(place) =>
                      setdropofflocation(
                        place?.formatted_address || place?.name || "",
                      )
                    }
                    options={{
                      types: ["(cities)"],
                      componentRestrictions: { country: "pk" },
                    }}
                  />
                  <button
                    className="customerrideselection-map-pin-btn"
                    onClick={() => {
                      setMapTarget("dropoff");
                      setShowMapModal(true);
                    }}
                    title="Pick on Map"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                        fill="#1B9B82"
                      />
                      <circle cx="12" cy="9" r="2.5" fill="#ffffff" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* MAP MODAL */}
        <Modal
          show={showMapModal}
          onHide={() => setShowMapModal(false)}
          fullscreen
          centered
          className="customerrideselection-map-modal"
        >
          <Modal.Header className="customerrideselection-map-modal__header">
            <button
              className="customerrideselection-map-modal__back"
              onClick={() => setShowMapModal(false)}
            >
              ←
            </button>
            <span className="customerrideselection-map-modal__title">
              {mapTarget === "pickup"
                ? "Select Pickup Location"
                : "Select Drop-off Location"}
            </span>
          </Modal.Header>
          <Modal.Body className="p-0" style={{ position: "relative" }}>
            <div
              ref={mapRef}
              className="customerrideselection-map-modal__map"
            />
            <div className="customerrideselection-map-modal__center-pin">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                  fill="#1B9B82"
                />
                <circle cx="12" cy="9" r="2.5" fill="#ffffff" />
              </svg>
            </div>
            <div className="customerrideselection-map-modal__confirm-wrap">
              {mapSelectedAddress && (
                <div className="customerrideselection-map-modal__address-bar">
                  <span>📌</span>
                  <span>{mapSelectedAddress}</span>
                </div>
              )}
              <Button
                className="customerrideselection-book-btn w-100"
                onClick={() => {
                  if (mapSelectedAddress) {
                    if (mapTarget === "pickup")
                      setpickuplocation(mapSelectedAddress);
                    else setdropofflocation(mapSelectedAddress);
                  }
                  setShowMapModal(false);
                }}
              >
                Confirm Location
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Route Preview */}
        {pickuplocation && dropofflocation && (
          <div className="customerrideselection-route-preview">
            <span className="customerrideselection-route-city">
              {pickuplocation}
            </span>
            <div className="customerrideselection-route-arrow">
              <FaRoad />
              <FaArrowRight />
            </div>
            <span className="customerrideselection-route-city">
              {dropofflocation}
            </span>
          </div>
        )}

        {/* Trip Details */}
        <Card className="customerrideselection-card">
          <Card.Body className="customerrideselection-card-body">
            <p className="customerrideselection-section-label">Trip Details</p>
            <Row className="g-3">
              <Col xs={6}>
                <label className="customerrideselection-field-label">
                  <FaCalendarAlt className="me-1" />
                  Date of Travel
                </label>
                <input
                  type="date"
                  className="form-control customerrideselection-date-input"
                  value={bookingDate}
                  min={today}
                  onChange={(e) => setBookingDate(e.target.value)}
                />
              </Col>
              <Col xs={6}>
                <label className="customerrideselection-field-label">
                  <FaClock className="me-1" />
                  Departure Time
                </label>
                <input
                  type="time"
                  className="form-control customerrideselection-date-input"
                  value={bookingTime}
                  onChange={(e) => setBookingTime(e.target.value)}
                />
              </Col>
              <Col xs={12}>
                <label className="customerrideselection-field-label">
                  <FaUsers className="me-1" />
                  Passengers
                </label>
                <div className="customerrideselection-counter">
                  <button
                    className="customerrideselection-counter-btn"
                    onClick={() => setPassengers(Math.max(1, passengers - 1))}
                  >
                    −
                  </button>
                  <span className="customerrideselection-counter-val">
                    {passengers}
                  </span>
                  <button
                    className="customerrideselection-counter-btn"
                    onClick={() => {
                      const next = Math.min(7, passengers + 1);
                      setPassengers(next);
                      if (next > 4) setBookingType("seater7");
                    }}
                  >
                    +
                  </button>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Vehicle Type */}
        <p className="customerrideselection-section-label">Choose Vehicle</p>
        <div className="customerrideselection-ride-types">
          {rideTypes.map((ride) => (
            <div
              key={ride.id}
              className={`customerrideselection-ride-card ${bookingType === ride.id ? "customerrideselection-ride-card--selected" : ""}`}
              onClick={() => {
                setvehicleType(ride.id);
                setBookingType(ride.id);
                setFareEdited(false);
              }}
            >
              <div className="customerrideselection-ride-icon">{ride.icon}</div>
              <div className="customerrideselection-ride-info">
                <h6 className="customerrideselection-ride-name">
                  {ride.label}
                </h6>
                <p className="customerrideselection-ride-desc">{ride.desc}</p>
                <div className="customerrideselection-seat-row">
                  {Array.from({ length: ride.seats }).map((_, i) => (
                    <span
                      key={i}
                      className={`customerrideselection-seat-dot ${i < passengers && bookingType === ride.id ? "customerrideselection-seat-dot--filled" : ""}`}
                    />
                  ))}
                  <span className="customerrideselection-seat-label">
                    {ride.seats} seats
                  </span>
                </div>
              </div>
              <div className="customerrideselection-ride-right">
                <span className="customerrideselection-ride-price">
                  PKR {ride.pricePerSeat.toLocaleString()}
                </span>
                <span className="customerrideselection-per-seat">/ seat</span>
                <div
                  className={`customerrideselection-radio ${bookingType === ride.id ? "customerrideselection-radio--selected" : ""}`}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Driver Preference */}
        <Card className="customerrideselection-card">
          <Card.Body className="customerrideselection-card-body">
            <p className="customerrideselection-section-label">
              Driver Preference
            </p>
            <Row className="g-2">
              <Col xs={6}>
                <div
                  className={`customerrideselection-driver-item ${driverType === "male" ? "customerrideselection-driver-item--active" : ""}`}
                  onClick={() => setDriverType("male")}
                >
                  <div className="customerrideselection-driver-radio">
                    <div
                      className={`customerrideselection-driver-radio-dot ${driverType === "male" ? "customerrideselection-driver-radio-dot--active" : ""}`}
                    />
                  </div>
                  <div className="customerrideselection-driver-info">
                    <span className="customerrideselection-driver-name">
                      Male Driver
                    </span>
                  </div>
                </div>
              </Col>
              <Col xs={6}>
                <div
                  className={`customerrideselection-driver-item ${driverType === "female" ? "customerrideselection-driver-item--active" : ""} ${!femaleAvailable ? "customerrideselection-driver-item--unavailable" : ""}`}
                  onClick={() => setDriverType("female")}
                >
                  <div className="customerrideselection-driver-radio">
                    <div
                      className={`customerrideselection-driver-radio-dot ${driverType === "female" ? "customerrideselection-driver-radio-dot--active" : ""}`}
                    />
                  </div>
                  <div className="customerrideselection-driver-info">
                    <span className="customerrideselection-driver-name">
                      Female Driver
                    </span>
                    <span
                      className={`customerrideselection-driver-desc ${!femaleAvailable ? "customerrideselection-driver-desc--unavailable" : ""}`}
                    >
                      {femaleAvailable ? "Available" : ""}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Trip Info */}
        <Card className="customerrideselection-tripinfo-card">
          <Card.Body>
            <Row className="text-center">
              <Col xs={4}>
                <FaClock className="customerrideselection-info-icon" />
                <p className="customerrideselection-info-label">Duration</p>
                <p className="customerrideselection-info-val">~4-5 hrs</p>
              </Col>
              <Col xs={4}>
                <FaRoad className="customerrideselection-info-icon" />
                <p className="customerrideselection-info-label">Distance</p>
                <p className="customerrideselection-info-val">~375 km</p>
              </Col>
              <Col xs={4}>
                <FaUsers className="customerrideselection-info-icon" />
                <p className="customerrideselection-info-label">Total Fare</p>
                <p className="customerrideselection-info-val customerrideselection-info-val--green">
                  PKR {finalFare.toLocaleString()}
                </p>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Smart Fare Bidding */}
        <Card className="customerrideselection-card">
          <Card.Body className="p-0">
            <p className="customerrideselection-section-label px-3 pt-3">
              Fare Offer
            </p>
            <Row className="customerrideselection-fare-row mx-0 px-3">
              <Col className="customerrideselection-fare-label">Base Fare</Col>
              <Col className="customerrideselection-fare-value text-end">
                PKR {getRide().pricePerSeat.toLocaleString()}
              </Col>
            </Row>
            <Row className="customerrideselection-fare-row mx-0 px-3">
              <Col className="customerrideselection-fare-label">
                Passengers × {passengers}
              </Col>
              <Col className="customerrideselection-fare-value text-end">
                PKR {getfareAmount().toLocaleString()}
              </Col>
            </Row>
            <div className="customerrideselection-bid-section mx-3 mb-3">
              <div className="customerrideselection-bid-label">
                <span>💬 Your Fare Offer</span>
                {fareEdited && (
                  <button
                    className="customerrideselection-bid-reset"
                    onClick={resetFareBid}
                  >
                    Reset to suggested
                  </button>
                )}
              </div>
              <div className="customerrideselection-bid-input-wrap">
                <span className="customerrideselection-bid-currency">PKR</span>
                <input
                  type="number"
                  className="customerrideselection-bid-input"
                  value={customerFareBid}
                  onChange={(e) => handleFareBidChange(e.target.value)}
                  min={0}
                />
              </div>
              <p className="customerrideselection-bid-hint">
                {fareEdited
                  ? customerFareBid < getfareAmount()
                    ? "⚠️ Lower offer may take longer to find a driver"
                    : "✅ Good offer! Driver will likely accept quickly"
                  : "You can adjust this amount. Driver will accept or counter offer."}
              </p>
            </div>

            {selectedOffer && (
              <div className="mx-3 mb-3 customerrideselection-discount-summary">
                <div className="d-flex justify-content-between mb-1 customerrideselection-discount-summary__row">
                  <span>Original Fare</span>
                  <span className="customerrideselection-discount-summary__original-fare">
                    PKR {baseFare.toLocaleString()}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-2 customerrideselection-discount-summary__row">
                  <span>
                    Offer Discount ({selectedOffer.discount_percent}%)
                  </span>
                  <span>- PKR {discountAmount.toLocaleString()}</span>
                </div>
                <hr className="customerrideselection-discount-summary__divider" />
                <div className="d-flex justify-content-between customerrideselection-discount-summary__total-row">
                  <span>You Pay</span>
                  <span>PKR {finalFareAfterDiscount.toLocaleString()}</span>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>


        {/* Payment Methods */}
        <p className="customerrideselection-section-label">Payment Method</p>
        <div className="customerrideselection-payment-methods">
          <div
            className={`customerrideselection-payment-card ${paymentMethod === "cash" ? "customerrideselection-payment-card--selected" : ""}`}
            onClick={() => setPaymentMethod("cash")}
          >
            <div className="customerrideselection-payment-icon customerrideselection-payment-icon--cash">
              <FaMoneyBillWave />
            </div>
            <div className="customerrideselection-payment-info">
              <h6 className="customerrideselection-payment-name">Cash</h6>
              <p className="customerrideselection-payment-desc">
                Pay driver directly after ride
              </p>
            </div>
            <div
              className={`customerrideselection-radio ${paymentMethod === "cash" ? "customerrideselection-radio--selected" : ""}`}
            />
          </div>

          <div
            className={`customerrideselection-payment-card ${paymentMethod === "coin" ? "customerrideselection-payment-card--selected" : ""}`}
            onClick={() => setPaymentMethod("coin")}
          >
            <div className="customerrideselection-payment-icon customerrideselection-payment-icon--coin">
              <FaCoins />
            </div>
            <div className="customerrideselection-payment-info">
              <h6 className="customerrideselection-payment-name">Coin Exchange</h6>
              <p className="customerrideselection-payment-desc">
                Use your Trustidrive reward coins
              </p>
            </div>
            <div
              className={`customerrideselection-radio ${paymentMethod === "coin" ? "customerrideselection-radio--selected" : ""}`}
            />
          </div>

          {/* Installment card — gated by eligibility */}
          <div
            className={`customerrideselection-payment-card customerrideselection-payment-card--installment ${paymentMethod === "installment" ? "customerrideselection-payment-card--selected" : ""} ${!isEligible ? "customerrideselection-payment-card--not-eligible" : ""}`}
            onClick={handleInstallmentCardClick}
          >
            <div className="customerrideselection-payment-icon customerrideselection-payment-icon--installment">
              <FaCreditCard />
            </div>
            <div className="customerrideselection-payment-info">
              <div className="customerrideselection-payment-name-row">
                <h6 className="customerrideselection-payment-name">Installments</h6>
                {isEligible ? (
                  <span className="customerrideselection-new-badge">NEW</span>
                ) : (
                  <span className="customerrideselection-locked-badge">
                    <FaLock size={8} /> Locked
                  </span>
                )}
              </div>
              <p className="customerrideselection-payment-desc">
                {isEligible
                  ? "Pay your fare in 3 easy monthly installments"
                  : "Complete more rides to unlock this option"}
              </p>
            </div>
            <div
              className={`customerrideselection-radio ${paymentMethod === "installment" ? "customerrideselection-radio--selected customerrideselection-radio--installment" : ""} ${!isEligible ? "customerrideselection-radio--disabled" : ""}`}
            />
          </div>

          {paymentMethod === "installment" && isEligible && (
            <div className="customerrideselection-installment-preview">
              <FaInfoCircle className="customerrideselection-installment-preview-icon" />
              <span>
                Total{" "}
                <span className="customerrideselection-installment-preview-amount">
                  PKR {finalFare.toLocaleString()}
                </span>{" "}
                — as low as{" "}
                <span className="customerrideselection-installment-preview-monthly">
                  PKR {Math.round((finalFare * 1.05) / 3).toLocaleString()}/mo
                </span>{" "}
                for 3 months.
              </span>
            </div>
          )}
        </div>

        {/* Book Button */}
        <Button
          className={`customerrideselection-book-btn ${paymentMethod === "installment" ? "customerrideselection-book-btn--installment" : ""}`}
          onClick={handleBookRide}
        >
          {paymentMethod === "installment"
            ? "Continue to Installment Plan →"
            : "Book Ride"}
        </Button>

        {/* SUCCESS MODAL */}
        <Modal show={showSuccessModal} centered backdrop="static">
          <Modal.Body className="customerrideselection-success-modal-body">
            <div className="customerrideselection-success-emoji">🎉</div>
            <h3 className="customerrideselection-success-title">
              Congratulations!
            </h3>
            <p className="customerrideselection-success-text">
              Your ride has been booked successfully.
              <br />
              <strong>Finding a driver for you...</strong>
            </p>
            <div
              className="spinner-border customerrideselection-success-spinner"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </Modal.Body>
        </Modal>

        {/* NOT ELIGIBLE MODAL */}
        <Modal
          show={showNotEligibleModal}
          centered
          onHide={() => setShowNotEligibleModal(false)}
          className="customerrideselection-noteligible-modal"
        >
          <Modal.Body className="customerrideselection-noteligible-body">
            <div className="customerrideselection-noteligible-icon">
              <FaLock />
            </div>
            <h5 className="customerrideselection-noteligible-title">
              You're Not Eligible Yet
            </h5>
            <p className="customerrideselection-noteligible-text">
              Installment payments unlock after completing{" "}
              <strong>10 rides</strong> on Trustidrive. You need{" "}
              <strong>{ridesRemaining} more ride{ridesRemaining === 1 ? "" : "s"}</strong>{" "}
              to unlock this option!
            </p>
            <Button
              className="customerrideselection-noteligible-btn"
              onClick={() => setShowNotEligibleModal(false)}
            >
              Got it
            </Button>
          </Modal.Body>
        </Modal>

        {/* INSTALLMENT PLAN MODAL */}
        <Modal
          show={showInstallmentModal}
          centered
          onHide={() => !confirmingInstallment && setShowInstallmentModal(false)}
          className="customerrideselection-modal"
        >
          <div className="customerrideselection-modal-header">
            <div>
              <div className="customerrideselection-installment-brand-row">
                <div className="customerrideselection-installment-brand-logo">
                  <FaCreditCard />
                  <span className="customerrideselection-installment-brand-text">
                    Trustidrive Installments
                  </span>
                </div>
              </div>
              <p className="customerrideselection-modal-title">
                Choose Your Plan
              </p>
              <p className="customerrideselection-modal-subtitle">
                Total Fare: PKR {finalFare.toLocaleString()}
              </p>
            </div>
            <button
              className="customerrideselection-modal-close"
              onClick={() => setShowInstallmentModal(false)}
              disabled={confirmingInstallment}
            >
              ✕
            </button>
          </div>
          <div className="customerrideselection-modal-body">
            <div className="customerrideselection-howit-wrap">
              {[
                { label: "Book Ride", icon: "🚗" },
                { label: "Choose Plan", icon: "📋" },
                { label: "Pay Monthly", icon: "💳" },
              ].map((step, i) => (
                <div key={i} className="customerrideselection-howit-step">
                  <div className="customerrideselection-howit-item">
                    <div className="customerrideselection-howit-icon">
                      {step.icon}
                    </div>
                    <p className="customerrideselection-howit-text">
                      {step.label}
                    </p>
                  </div>
                  {i < 2 && (
                    <div className="customerrideselection-howit-divider" />
                  )}
                </div>
              ))}
            </div>
            <div className="customerrideselection-plans-wrap">
              {plans.map((plan) => (
                <div
                  key={plan.id}
                  className={`customerrideselection-plan-card ${selectedPlan === plan.id ? "customerrideselection-plan-card--selected" : ""}`}
                  onClick={() => setSelectedPlan(plan.id)}
                >
                  <div className="customerrideselection-plan-top">
                    <div className="customerrideselection-plan-title-row">
                      <h6 className="customerrideselection-plan-title">
                        {plan.title}
                      </h6>
                      <span
                        className="customerrideselection-plan-badge"
                        style={{ background: plan.badgeColor }}
                      >
                        {plan.badge}
                      </span>
                    </div>
                    <div
                      className={`customerrideselection-radio ${selectedPlan === plan.id ? "customerrideselection-radio--selected customerrideselection-radio--installment" : ""}`}
                    />
                  </div>
                  <p className="customerrideselection-plan-desc">{plan.desc}</p>
                  <div className="customerrideselection-plan-breakdown">
                    <div className="customerrideselection-breakdown-row">
                      <span>Ride Fare</span>
                      <span>PKR {finalFare.toLocaleString()}</span>
                    </div>
                    <div className="customerrideselection-breakdown-row">
                      <span>Service Fee (5%)</span>
                      <span className="customerrideselection-val-fee">
                        + PKR {plan.serviceFee.toLocaleString()}
                      </span>
                    </div>
                    <div className="customerrideselection-breakdown-row customerrideselection-breakdown-row--highlight">
                      <span>Monthly × {plan.months}</span>
                      <span className="customerrideselection-val-green">
                        PKR {plan.monthly.toLocaleString()}/mo
                      </span>
                    </div>
                    <div className="customerrideselection-breakdown-row">
                      <span>Total Payable</span>
                      <strong>PKR {plan.totalPayable.toLocaleString()}</strong>
                    </div>
                  </div>
                  <div className="customerrideselection-plan-perks">
                    {plan.perks.map((perk, i) => (
                      <div key={i} className="customerrideselection-perk-row">
                        <FaCheckCircle className="customerrideselection-perk-icon" />
                        <span>{perk}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="customerrideselection-security-note">
              <FaShieldAlt className="customerrideselection-security-icon" />
              Your installment plan is managed and secured directly by
              Trustidrive
            </div>
          </div>
          <div className="customerrideselection-modal-footer">
            <Button
              className="customerrideselection-modal-cancel"
              onClick={() => setShowInstallmentModal(false)}
              disabled={confirmingInstallment}
            >
              Cancel
            </Button>
            <Button
              className="customerrideselection-modal-confirm"
              onClick={handleInstallmentConfirm}
              disabled={!selectedPlan || confirmingInstallment}
            >
              {confirmingInstallment ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  />
                  Booking...
                </>
              ) : (
                "Confirm & Book Ride"
              )}
            </Button>
          </div>
        </Modal>
      </Container>
      <BottomNav />
    </div>
  );
};

export default CustomerRideSelection;